import React from 'react'

export default function ButtonSecondary(props) {
    return (
        <button className={props.classValue} onClick={props.onClick} datatype={props.datatype} datapath={props.datapath}>
            <span datatype={props.datatype} datapath={props.datapath}>{props.textValue}</span>
        </button>
    )
}
